<template>
  <collection-form :value="collection" :title="pageTitle" @submit="save">
    <template slot="actions">
      <form-button kind="submit" type="submit">Enregistrer</form-button>
      <form-button kind="cancel" @click="$router.go(-1)">Annuler</form-button>
    </template>
  </collection-form>
</template>

<script>
  import CollectionForm from './CollectionForm.vue';

  import CollectionCreateMutation from './graphql/CollectionCreateMutation.gql';

  export default {
    components: {
      CollectionForm,
    },
    data() {
      const {category = null, search = null} = this.$route.query || {};
      return {
        collection: {
          categories: category? [{id: category}]: [],
          name: search,
          order: 50,
          published: false,
        },
      };
    },
    methods: {
      async save(data) {
        try {
          await this.$apollo.mutate({
            mutation: CollectionCreateMutation,
            variables: {
              data,
            },
          });

          this.$store.dispatch('addNotificationSuccess', `La collection a été créée !`);
          this.$router.push({name: 'collections'});

        } catch (err) {
          if (err.message.match(/duplicate/)) {
            return this.$store.dispatch('addNotificationError', `L'alias est déjà utilisé par une autre collection !`);
          }
          this.$store.dispatch('addNotificationError', err.message);
        }
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/collections/CollectionCreate.vue